import TestiImg1 from "../assets/images/resources/testiImg1-1.jpg";
import TestiImg2 from "../assets/images/resources/testiImg1-2.jpg";
import TestiImg3 from "../assets/images/resources/testiImg1-3.jpg";

import StarRate from "../assets/images/5starRate.png";

export const testimonials = [
  {
    testiImg: TestiImg1,
    testiTitle: "Paul M. Matney",
    testiDesi: "Lawyer",
    testiDesc:
      "We're really proud of the work we've done together. Whether it's a brand or a new online business, we jump in passionately with both feet.",
    testiRate: StarRate,
  },
  {
    testiImg: TestiImg2,
    testiTitle: "John Doe",
    testiDesi: "Lawyer",
    testiDesc:
      "We're really proud of the work we've done together. Whether it's a brand or a new online business, we jump in passionately with both feet.",
    testiRate: StarRate,
  },
  {
    testiImg: TestiImg3,
    testiTitle: "Ema Doe",
    testiDesi: "Paralegal",
    testiDesc:
      "We're really proud of the work we've done together. Whether it's a brand or a new online business, we jump in passionately with both feet.",
    testiRate: StarRate,
  },
];
